import { ExternalLink, Text } from "@clipboard-health/ui-react";

import { APP_V2_USER_EVENTS, logEvent } from "../lib/analytics";
import { type SupportArticle } from "./types";

interface SupportArticleLinkProps {
  supportArticle: SupportArticle;
}

export function SupportArticleLink(props: SupportArticleLinkProps) {
  const { supportArticle } = props;

  return (
    <ExternalLink
      underline="hover"
      to={supportArticle.attributes.distributionUrl}
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.HELP_CENTER_ARTICLE_OPENED, {
          id: supportArticle.id,
          title: supportArticle.attributes.title,
          category: supportArticle.attributes.category,
        });
      }}
    >
      <Text color="inherit">{supportArticle.attributes.title}</Text>
    </ExternalLink>
  );
}
